<script setup>
import { AgGridVue } from 'ag-grid-vue3';
import { computed, ref, watch } from 'vue';
import MaterialEditableCellRenderer from '@/Components/CellRenderers/MaterialEditableCellRenderer.vue';

const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    rows: {
        type: Array,
        default: () => [],
    },
    dense: {
        type: Boolean,
        default: false,
    },
    edit: {
        type: Boolean,
        default: true,
    },
});

const inventory = defineModel({
    type: Object,
    required: true,
});

watch(
    () => props.rows,
    () => {
        inventory.value = props.rows.map((row) => ({
            ...row,
            counted_quantity: row.counted_quantity || null,
        }));
    },
);

const columnDefs = computed(() => {
    const columns = [
        {
            headerName: 'Artikelnummer',
            field: 'item_number',
            width: 100,
        },
        {
            headerName: 'Artikel',
            field: 'description',
            width: 200,
        },
        {
            headerName: 'Charge',
            field: 'lot_number',
            width: 100,
        },
        {
            headerName: 'Einheit',
            field: 'unit',
            width: 100,
        },
        {
            headerName: 'Lagerplatz',
            field: 'bin_code',
        },
        {
            headerName: 'Anzahl',
            field: 'quantity',
            width: 100,
        },
    ];

    const countColumn = {
        headerName: 'Zählmenge',
        field: 'counted_quantity',
        editable: true,
        cellRenderer: MaterialEditableCellRenderer,
        cellEditor: 'agNumberCellEditor',
        cellEditorParams: {
            min: 0,
            precision: 0,
            step: 1,
            showStepperButtons: true,
        },
        width: 100,
        type: 'rightAligned',
    };

    if (!props.edit) {
        countColumn.editable = false;
        countColumn.cellRenderer = undefined;
    }

    columns.push(countColumn);

    return columns;
});

const onCellEditingStopped = () => {
    inventory.value = _.cloneDeep(inventory.value);
};

const gridApi = ref(null);
const onGridReady = (params) => {
    gridApi.value = params.api;
};
const stopEditing = () => {
    if (gridApi.value) {
        gridApi.value.stopEditing();
    }
};

defineExpose({
    stopEditing,
});
// TODO: stop editing on blur
</script>

<template>
    <div v-if="loading" class="tw-flex tw-h-6 tw-w-full tw-items-center">
        <v-progress-circular
            indeterminate
            color="primary"
            class="tw-m-auto"
        ></v-progress-circular>
    </div>
    <ag-grid-vue
        v-else
        class="ag-theme-material"
        :class="{ 'ag-theme-material-dense': dense }"
        dom-layout="autoHeight"
        :column-defs
        :row-data="inventory"
        :single-click-edit="true"
        :stop-editing-when-cells-lose-focus="true"
        @cell-editing-stopped="onCellEditingStopped"
        @grid-ready="onGridReady"
    ></ag-grid-vue>
</template>

<style scoped></style>
